import { Divider } from 'antd';
import 'antd/es/divider/style/index';
import './index.less';

export default Divider;
